import createVueComponent from '../createVueComponent';

const StretchHorizontal = createVueComponent('StretchHorizontalIcon', [
  [
    'rect',
    { width: '20', height: '6', x: '2', y: '4', rx: '2', key: 'qdearl' },
  ],
  [
    'rect',
    { width: '20', height: '6', x: '2', y: '14', rx: '2', key: '1xrn6j' },
  ],
]);

export default StretchHorizontal;
